import React from "react";
import { Card, CardContent, Box, Typography, CardHeader } from "@mui/material";

import JPAvatar from "../JPAvatar";

function JobPlanErrorCard({ error, message }) {
    return (
        <Card sx={{ width: "100%" }} className="card">
            <CardHeader
                avatar={<JPAvatar type="jobplan" />}
                title={
                    <Typography variant="h2" className="card-header-title">
                        Job planner
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {error}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body1">{message}</Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default JobPlanErrorCard;
